import React from 'react'

const PulseLoader = () => {
    return (
        <>
            <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </>
    )
}

export default PulseLoader